module.exports = "<div class=\"floating-bottom\" (click)=\"showHideEncuesta()\">\n    <mat-icon aria-hidden=\"false\" aria-label=\"Example home icon\" class=\"icon\">home</mat-icon> Observación de la Cotidianidad\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/encuesta/encuesta.component.html
// module id = ./src/app/components/shared/encuesta/encuesta.component.html
// module chunks = main